<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        align="center"
        prop="act_name"
        label="活动名称"
        width="180"
      />
      <!-- <el-table-column
        align="center"
        prop="sign"
        label="活动标识"
        width="180"
      /> -->
      <el-table-column
        prop="amount_type"
        label="红包金额"
        width="180"
        align="center"
      >
        <template scope="scope">
          <div v-if="scope.row.amount_type == 2">
            最小：{{ scope.row.amount_random[0] }}
            最大：{{ scope.row.amount_random[1] }}
          </div>
          <div v-if="scope.row.amount_type == 1">
            {{ scope.row.total_amount }}
          </div>

        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="platform_name"
        label="平台名称"
        width="180"
      />
      <el-table-column
        align="center"
        prop="sign"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择红包活动</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>

</template>

<script>
import { redPacketActivitylist } from '@/api/weChatMerchants.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      newtotalr: null,
      objr: {
        page: 1,
        pageSize: 10,
        status: 2
      },
      id: null,
      type: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(id, type) {
      console.log('平台type', type)
      this.id = id
      this.type = type
      this.activelist()
    },
    async activelist() {
      const data = await redPacketActivitylist({
        ...this.objr,
        platform_id: this.id
      })
      this.tableData = data.data.list
      this.newtotalr = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.activelist()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.activelist()
    },
    choose(item) {
      console.log('item', item)
      this.$emit('redcallback', item, this.type)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
